// Zentrale Konfiguration für den Insight-Access (Kauf von Vortragsaufzeichnungen).
// Wird verwendet im Banner auf AllEventLectures.jsx und im Shop.jsx.

export const LOUNGES_2026_EVENT_ID = "cb7a916e-ed71-483a-8177-22532ab0b237";

// Werden vom Seed-Script (scripts/seed-lounges26-insight-product.js) erzeugt.
// Nach dem ersten Seed bitte hier eintragen.
// - Visitor-Variante: 250€, allowedBuyerGroups enthält "event_<2026>"
// - Non-Visitor-Variante: 500€, allowedBuyerGroups enthält "not_event_<2026>"
export const LOUNGES_2026_INSIGHT_VISITOR_PRODUCT_ID = "ab084b90-041b-46a1-b34d-e6d81918af97";
export const LOUNGES_2026_INSIGHT_NON_VISITOR_PRODUCT_ID = "8193d763-50e9-41ab-89ea-e8112911108f";

// Preise wie Lounges 2025.
export const LOUNGES_2026_INSIGHT_VISITOR_PRICE = 250;
export const LOUNGES_2026_INSIGHT_NON_VISITOR_PRICE = 500;

export const LOUNGES_INDUSTRY_ID = "ec37b0b2-7f72-4de4-b12b-5eac5ff71ae3";
